import axios from 'axios'
import { config } from '@/config/config'
import xmlbuilder from 'xmlbuilder'
import xml2js from 'xml2js'

// Function to convert JSON to XML
function jsonToXml (json, rootName = 'root') {
    const root = xmlbuilder.create(rootName)

    // Check if 'data' key exists in the JSON object
    if ('data' in json && Array.isArray(json.data)) {
        const dataArray = json.data

        // Iterate over each item in the 'data' array
        dataArray.forEach((item) => {
            const dataElement = root.ele('data')

            // Iterate over key-value pairs in each item
            Object.entries(item).forEach(([key, value]) => {
                dataElement.ele(key).txt(value)
            })
        })
    }

    return root.end({ pretty: true })
}

// Function to convert XML to JSON
function xmlToJson (xmlString) {
    return new Promise((resolve, reject) => {
        const parser = new xml2js.Parser({ explicitArray: false, mergeAttrs: true })
        parser.parseString(xmlString, (err, result) => {
            if (err) {
                reject(err)
            } else {
                resolve(result)
            }
        })
    })
}

async function getConsumer (jsonData, nrorg) {
    return sendXmlData({ data: [jsonData] }, 'getConsumer', nrorg)
}

async function getClientLayout (jsonData, nrorg) {
    return sendXmlData({ data: [jsonData] }, 'getClientLayout', nrorg)
}

function updateConsumer (jsonData, nrorg) {
    return sendXmlData({ data: [jsonData] }, 'updateConsumer', nrorg)
}

function registerConsumer (jsonData, nrorg) {
    return sendXmlData({ data: [jsonData] }, 'registerConsumer', nrorg)
}

// Interceptor para transformar nomes de cabeçalhos para minúsculas
axios.interceptors.request.use((config) => {
    const headers = config.headers
    const lowercaseHeaders = {}

    Object.keys(headers).forEach((header) => {
        lowercaseHeaders[header.toLowerCase()] = headers[header]
    })

    config.headers = lowercaseHeaders
    return config
}, (error) => {
    return Promise.reject(error)
})

// Function to send XML data via Axios POST request
async function sendXmlData (jsonData, uri, nrorg = null) {
    const xmlData = jsonToXml(jsonData)
    try {
        const response = await axios.post(config.apiUrl + uri, xmlData, {
            headers: {
                'x-client-name': config.isSaas === 'true' ? nrorg : 'NOT_SAAS',
                'x-client-env': config.isSaas === 'true' ? nrorg : 'NOT_SAAS',
                'x-client-type': config.isSaas === 'true' ? 'SAAS' : 'NOT_SAAS',
                'Content-Type': 'application/xml',
                Authorization: 'Basic dGVrbmlzYTp0ZWtuaXNh'
            }
        })
        return xmlToJson(response.data)
    } catch (error) {
        console.log(error)
        console.log(error.response)
        return xmlToJson(error?.response?.data || '')
    }
}

export default { updateConsumer, getConsumer, registerConsumer, getClientLayout }
